import {
  REQUEST_KOL_MAPPING,
  RESPONSE_KOL_MAPPING,
  FAILURE_KOL_MAPPING,
  UPDATE_INTERNAL_KOL,
  UPDATE_TARGET_KOL,
  REQUEST_KOL_ARTICLES,
  RESPONSE_KOL_ARTICLES,
  FAILUTE_KOL_ARTILCES,
  UPDATE_KOL_SELECTED_PAIRS,
  UPDATE_KOL_TERMS,
  KOL_CLEAR_RESULTS
} from "../../actions/types";

const initialState = {
  error: false,
  isLoading: false,
  internal_kol: [],
  target_kol: [],
  results: [],
  articles: [],
  selectedPairs: [],
  activePage: 1,
  size: 10,
  totalArticles: 0,
  isArticlesLoading: false,
  terms: [],
  affiMatch: [],
  tree: {},
  operator: "AND"
};

const requestArticles = (state, action) => {
  const selectedPairs = action.payload.selectedPairs || [];
  const activePage = action.payload.activePage;
  return {
    ...state,
    isArticlesLoading: true,
    selectedPairs: selectedPairs,
    articles: [],
    activePage
  };
};

const responseArticles = (state, action) => {
  const articles = action.payload.articles || [];
  const totalArticles = action.payload.totalArticles;
  return {
    ...state,
    isArticlesLoading: false,
    articles: articles,
    totalArticles: totalArticles
  };
};

const failureArticles = (state, action) => {
  return {
    ...state,
    isArticlesLoading: false
  };
};

const setFetching = (state, action) => {
  return {
    ...state,
    isLoading: true,
    error: false
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    error: true,
    results: []
  };
};

const setResults = (state, action) => {
  let { infos } = action.payload || {};
  infos = infos || {};
  let { internal_kol, target_kol } = infos;
  let results = action.payload.results.article_match || [];
  let statusCode = action.payload.statusCode;
  let selectedPairs = [];
  let affiMatch = action.payload.results.affi_match || [];
  if (results.length > 0) {
    selectedPairs = results[0].pairs;
  }

  target_kol = target_kol || [];
  internal_kol = internal_kol || [];

  const tree = {};
  for (let i of [...internal_kol, ...target_kol]) {
    tree[i.expertId || i.id] = i;
  }

  return {
    ...state,
    isLoading: false,
    error: false,
    results,
    statusCode,
    selectedPairs,
    affiMatch,
    tree,
    ...infos
  };
};

const updateTargetKol = (state, action) => {
  let target_kol = action.payload.target_kol || [];
  return {
    ...state,
    target_kol,
    results: []
  };
};

const updateInternalKol = (state, action) => {
  let internal_kol = action.payload.internal_kol || [];
  return {
    ...state,
    internal_kol,
    results: []
  };
};

const updateSelectedPairs = (state, action) => {
  let selectedPairs = action.payload.selectedPairs || [];

  return {
    ...state,
    selectedPairs
  };
};

const updateTerms = (state, action) => {
  let terms = action.payload.terms || [];
  let operator = action.payload.operator || "OR";

  return {
    ...state,
    terms,
    results: [],
    operator
  };
};

const clearResults = (state, action) => {
  return {
    ...initialState
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_KOL_MAPPING:
      return setFetching(state, action);
      break;

    case RESPONSE_KOL_MAPPING:
      return setResults(state, action);

    case FAILURE_KOL_MAPPING:
      return setFailure(state, action);

    case UPDATE_INTERNAL_KOL:
      return updateInternalKol(state, action);

    case UPDATE_TARGET_KOL:
      return updateTargetKol(state, action);

    case REQUEST_KOL_ARTICLES:
      return requestArticles(state, action);

    case RESPONSE_KOL_ARTICLES:
      return responseArticles(state, action);

    case FAILUTE_KOL_ARTILCES:
      return failureArticles(state, action);

    case UPDATE_KOL_SELECTED_PAIRS:
      return updateSelectedPairs(state, action);

    case UPDATE_KOL_TERMS:
      return updateTerms(state, action);
    
    case KOL_CLEAR_RESULTS:
      return clearResults(state, action)

    default:
      return state;
      break;
  }
};
